import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-2 sm:space-x-3">
            <div className="w-10 h-10 bg-amber-500 rounded-lg flex items-center justify-center">
              <i className="ri-taxi-line text-2xl text-white"></i>
            </div>
            <span className={`text-lg sm:text-xl font-bold ${isScrolled ? 'text-slate-900' : 'text-white'}`}>
              Utrecht Airport Taxi
            </span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className={`font-medium hover:text-amber-500 transition-colors ${
              isScrolled ? 'text-slate-700' : 'text-white'
            }`}>
              Home
            </Link>
            <Link to="/taxi-utrecht-schiphol" className={`font-medium hover:text-amber-500 transition-colors ${
              isScrolled ? 'text-slate-700' : 'text-white'
            }`}>
              Taxi Schiphol
            </Link>
            <Link to="/prijs-berekenen" className={`font-medium hover:text-amber-500 transition-colors ${
              isScrolled ? 'text-slate-700' : 'text-white'
            }`}>
              Prijs Berekenen
            </Link>
            <Link to="/werkgebied" className={`font-medium hover:text-amber-500 transition-colors ${
              isScrolled ? 'text-slate-700' : 'text-white'
            }`}>
              Werkgebied
            </Link>
            <a href="tel:+31658824429" className="px-5 sm:px-6 py-2.5 sm:py-3 bg-amber-500 text-white rounded-lg font-semibold hover:bg-amber-600 transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base">
              <i className="ri-phone-line mr-2"></i>Bel Nu
            </a>
            <a
              href="https://wa.me/31658824429?text=Hallo,%20ik%20wil%20graag%20een%20taxi%20boeken%20naar%20de%20luchthaven."
              target="_blank"
              rel="noopener noreferrer"
              className="hidden lg:inline-flex items-center gap-2 px-5 py-2.5 bg-green-500 text-white font-semibold rounded-lg hover:bg-green-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line"></i>
              WhatsApp
            </a>
          </div>

          <button className="md:hidden">
            <i className={`ri-menu-line text-3xl ${isScrolled ? 'text-slate-900' : 'text-white'}`}></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
